import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import PwaInstallBanner from "@/components/feature/PwaInstallBanner";
import WhatsAppButton from "@/components/feature/WhatsAppButton";
import MobileBottomNav from "@/components/feature/MobileBottomNav";


function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <AppRoutes />
        <MobileBottomNav />
        <WhatsAppButton />
        <PwaInstallBanner />
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;
